import { NgModule } from '@angular/core'
import { MaskedInputDirective } from './text-mask.directive'


@NgModule({
  declarations: [MaskedInputDirective],
  exports: [MaskedInputDirective]
})
export class TextMaskModule {}